import {onDomReady} from "../../components/dynamic/observer";

class Header {
    constructor(header) {
        this.header = header;
        this.lastScrollY = 0;
        this.ticking = false;

        this.init();
        this.initScrollHandler();
    }

    init() {
        this.openMenu();
        this.initHiddenAttribute();
    }

    initHiddenAttribute() {
        this.dropdownMenus = this.header.querySelectorAll('[data-dropdown-menu][hidden]');
    }

    removeHidden(menuElement) {
        if (menuElement && menuElement.hasAttribute('hidden')) {
            menuElement.removeAttribute('hidden');
        }
    }

    addHidden(menuElement) {
        if (menuElement && !menuElement.hasAttribute('hidden')) {
            menuElement.setAttribute('hidden', '');
        }
    }

    initScrollHandler() {
        window.addEventListener('scroll', () => {
            if (!this.ticking) {
                requestAnimationFrame(() => {
                    this.updateHeaderPosition();
                    this.ticking = false;
                });
                this.ticking = true;
            }
        }, {passive: true});
    }

    updateHeaderPosition() {
        const scrollY = window.scrollY;

        if (scrollY > 100) {
            if (scrollY > this.lastScrollY) {
                this.header.classList.add('_fixed');
            } else {
                if (scrollY < 100) {
                    this.header.classList.remove('_fixed');
                }
            }
        } else {
            this.header.classList.remove('_fixed');
        }

        this.lastScrollY = scrollY;
    }

    openMenu() {
        // ну че народ, погнали на*уй
        const dropdownGroups = this.header.querySelectorAll('[data-header-dropdown-group]');

        dropdownGroups.forEach(group => {
            let closeTimer;
            let hoveredItem = null;
            const dropdownMenu = group.querySelector('[data-dropdown-menu]');

            group.addEventListener('mouseenter', () => {
                clearTimeout(closeTimer);
                group.classList.add('_open');
                this.header.classList.add('_open');
                document.body.classList.add('_no-scroll');

                if (dropdownMenu) {
                    this.removeHidden(dropdownMenu);
                }

                group.querySelectorAll('.header__dropdown-item, .header__nav-drop, .header__dropdown-item-separator').forEach(item => {
                    item.classList.remove('_grey');
                });
            });

            group.addEventListener('mouseleave', () => {
                // closeTimer = setTimeout(() => {

                if (dropdownMenu) {
                    this.addHidden(dropdownMenu);
                }

                group.classList.remove('_open');
                this.header.classList.remove('_open');
                document.body.classList.remove('_no-scroll');

                group.querySelectorAll('.header__dropdown-item, .header__nav-drop, .header__dropdown-item-separator').forEach(item => {
                    item.classList.remove('_active', '_grey');
                });
                hoveredItem = null;
                // }, 30);
            });

            group.addEventListener('mousemove', (e) => {
                const newHoveredItem = e.target.closest('.header__dropdown-item, .header__nav-drop');
                const hoveredLi = e.target.closest('.header__dropdown-item');

                if (newHoveredItem !== hoveredItem) {
                    hoveredItem = newHoveredItem;

                    group.querySelectorAll('.header__dropdown-item, .header__nav-drop, .header__dropdown-item-separator').forEach(item => {
                        item.classList.remove('_active', '_grey');
                    });

                    if (hoveredItem && hoveredLi) {
                        hoveredLi.classList.add('_active');
                        hoveredItem.classList.add('_active');

                        const items = Array.from(group.querySelectorAll('.header__dropdown-item:not(.header__dropdown-item_mobile)'));
                        const hoveredIndex = items.indexOf(hoveredLi);

                        if (hoveredIndex === 1) {
                            [6, 4].forEach(index => {
                                if (index < items.length) {
                                    items[index].classList.add('_active');
                                    const link = items[index].querySelector('.header__nav-drop');
                                    if (link) {
                                        link.classList.add('_active');
                                    }
                                }
                            });
                        }

                        group.querySelectorAll('.header__dropdown-item, .header__nav-drop, .header__dropdown-item-separator').forEach(item => {
                            if (!item.classList.contains('_active')) {
                                item.classList.add('_grey');
                            }
                        });
                    }
                }
            });
        });
    }
}

onDomReady(() => {
    const header = document.querySelector('[data-header]');

    if (header) {
        new Header(header);
    }
})